var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MultiAssignField',{attrs:{"type":"select","label":"Brand","name":"brands","options":_vm.brandOptions,"value":_vm.assigned}})
}
var staticRenderFns = []

export { render, staticRenderFns }